<mat-toolbar class="shadow-sm">
    <button mat-mini-fab color="primary" class="me-2" (click)="uiStore.leftMenuRef?.toggle()">
        <mat-icon>menu</mat-icon>
    </button>
    <!-- <img title="Alabama Certification for Educators" class="h-100 py-1 desktop-only" src="../assets/img/logo-full.png" />
    <img title="Alabama Certification for Educators" class="h-100 py-1 phone-only" src="../assets/img/logo-profile.png" />
    <a class="log-tag" routerLink="/"></a> -->
    <span class="header-logo-text h1 mt-2" color="primary">ACE Admin</span>
    <span class="example-spacer"></span>
    <button mat-mini-fab color="primary" class="mx-1" (click)="openHelp()" matTooltip="View help guide">
        <mat-icon>help_outline</mat-icon>
    </button>
    <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <a *ngIf="getUser().uid" [routerLink]="['/app']" mat-menu-item>
            <mat-icon color="accent">home</mat-icon>
            <span>Home</span>
        </a>
        <a *ngIf="getUser().uid" target="_blank" href="{{environment.externalUrl.alsdeUserProfile}}" mat-menu-item>
            <mat-icon color="accent">person</mat-icon>
            <span>User Profile (AIM)</span>
        </a>
        <a *ngIf="getUser().uid" [routerLink]="['/app/message-center']" mat-menu-item>
            <mat-icon color="accent">email</mat-icon>
            <span>Message Center</span>
        </a>
        <button *ngIf="getUser().uid" (click)="logout()" mat-menu-item><mat-icon color="accent">logout</mat-icon>
            <span>Logout</span>
        </button>
        <a *ngIf="!getUser().uid" [routerLink]="['/auth']" (click)="login()" mat-menu-item>
            <mat-icon color="accent">login</mat-icon>
            <span>Login</span>
        </a>
    </mat-menu>
</mat-toolbar>